// extracted by mini-css-extract-plugin
module.exports = {"icon":"GeneratingLabel_icon__1NoLr","load":"GeneratingLabel_load__2Qx0Z"};